import utils from "./react-utilities";
import Settings from "./settings";
import { message, Image, Button } from "antd";
const CustomFunctions = {
    async viewStudentPayments(record, drawer, valuesStore, studentStatementPrintableRef, ReactToPrint) {

        let res = await utils.requestWithReauth('post', `${Settings.root}/tpapi/get_student_payments`, null, { indexNo: record.index_no });
        if (res.status != 'Ok') {
            utils.showNotification('Attention', res.msg);
            return;
        }

        let bio = await utils.requestWithReauth('post', `${Settings.backend}/get_student_details`, null, { index_no: record.index_no });
        const details = bio.result[0];
        const { Firstname, Lastname, Middlename, ApplicantID, Campus,
            Citizenship, CurrentSemesterName, Department, Gender, IndexNumber,
            Level, PersonalEmail, Program, Status, Stream, StudentType, Telephone, Title } = details;


        const d = valuesStore.getArrayObjectsValue('settings', 'prop', 'student_admission_data_endpoint');
        let res1 = await utils.requestWithReauth('post', d.value, null, { applicant_id: ApplicantID });
        const picPath = res1?.res?.filter(v => {
            if (v.lookup_item == 'picture' && v.item.toLowerCase() == 'path') {
                return v;
            }
        });

        const { currency, simple2DArray } = res;
        const domain = utils.getDomainFromUrl(d.value);
        const table = utils.getTable([`Debit (${currency})`, `Credit (${currency})`, `Balance (${currency})`, 'Level', 'AcadYr.', 'Bank', 'Mode', 'Date','Narration','Admin'], simple2DArray, 'w-100 table table-striped ', 'fw-boldx', 'fw-boldx', 'fw-boldx');
        const content = <div>
            <div className="mb-2 border-bottom p-2">
                <ReactToPrint
                    trigger={() => <Button className='btn-info border-0 ms-2'> <i className='fas fa-print me-2' />Print out</Button>}
                    content={() => studentStatementPrintableRef.current}
                />
            </div>
            <div className="container mt-3" ref={studentStatementPrintableRef}>
                <div className="row" >
                    <div className="col-md-3">
                        {
                            (picPath && picPath.length) ? <Image
                                width={150}
                                src={`https://${domain}/applicant/${picPath[0]?.value}`}
                            />
                                :
                                <Image
                                    fallback="data:image/png;base64,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"
                                    width={150}
                                />
                        }
                    </div>
                    <div className="col-md-9">
                        <div className="row row-cols-2">
                            <div className="d-flex flex-column border-end">
                                <label>Title: {Title}</label>
                                <label>First Name: {Firstname}</label>
                                <label>Last Name: {Lastname}</label>
                                <label>Middle Name: {Middlename}</label>
                                <label>Gender: {Gender}</label>
                                <label>Index Number: {IndexNumber}</label>
                            </div>
                            <div className="d-flex flex-column">
                                <label>Program: {Program}</label>
                                <label>Level: {Level}</label>
                                <label>Session: {Stream}</label>
                                <label>Department: {Department}</label>
                                <label>Campus: {Campus}</label>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="table-responsive">
                            {table}
                        </div>
                    </div>
                </div>
            </div>

        </div >
        drawer.setOpen(true);
        drawer.setPlacement('right');
        drawer.setClosable(false);
        drawer.setTitle(`Student Statement`);
        drawer.setWidth(800);
        drawer.setContent(content);
    },
    async viewStudentBasicData(record, drawer, valuesStore) {
        let res = await utils.requestWithReauth('post', `${Settings.backend}/get_student_details`, null, { index_no: record.index_no });
        const details = res.result[0];
        const { Firstname, Lastname, Middlename, ApplicantID, Campus,
            Citizenship, CurrentSemesterName, Department, Gender, IndexNumber,
            Level, PersonalEmail, Program, Status, Stream, StudentType, Telephone, Title, StartAcadYr, EndAcadYr } = details;

        const d = valuesStore.getArrayObjectsValue('settings', 'prop', 'student_admission_data_endpoint');
        const emailSuffix = valuesStore.getArrayObjectsValue('settings', 'prop', 'student_mail_suffix');
        // console.log(d,details);
        // return;
        let res1 = await utils.requestWithReauth('post', d.value, null, { applicant_id: ApplicantID });
        const picPath = res1?.res?.filter(v => {
            if (v.lookup_item == 'picture' && v.item.toLowerCase() == 'path') {
                return v;
            }
        });
        
        drawer.setOpen(true);
        drawer.setPlacement('right');
        drawer.setClosable(false);
        drawer.setTitle(`Details of ${Lastname} ${IndexNumber}`);
        drawer.setWidth(520);

        const data = [
            ['Title', Title],
            ['First Name', Firstname],
            ['Last Name', Lastname],
            ['Middle Name', Middlename],
            ['Gender', Gender],
            ['Citizen Of', Citizenship],            
            ['ApplicantID', ApplicantID],
            ['Index Number', IndexNumber],
            ['Program', Program],
            ['Start Acad. Yr.', StartAcadYr],
            ['End Acad. Yr.', EndAcadYr],
            ['Session', Stream],
            ['Level', Level],
            ['Department', Department],
            ['Campus', Campus],
            ['Telephone', Telephone],
            ['Personal Email', PersonalEmail],
            ['Student Email', `${IndexNumber}@${emailSuffix.value}`],
            ['Student Type', StudentType],
            ['Status', Status],
        ];
        const domain = utils.getDomainFromUrl(d.value);
        const table = utils.getTable([], data, 'w-100 table table-striped table-sm', '', '', 'fw-bold');
        const content = <div>
            {
                (picPath && picPath.length) ? <Image
                    width={200}
                    src={`https://${domain}/applicant/${picPath[0]?.value}`}
                />
                    :
                    <Image
                        fallback="data:image/png;base64,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"
                        width={200}
                    />
            }
            {table}
        </div>
        drawer.setContent(content);
        // setStudentViewLoading(false);
    },

    async viewTxn(record, drawer, valuesStore, Tag, Divider, Space, isMainTxn = true) {
        const res = await utils.requestWithReauth('post', `${Settings.backend}/get_student`, null, { indexNumber: record.index_no });
        const student = res?.result[0];
        drawer.setOpen(true);
        drawer.setPlacement('right');
        drawer.setClosable(false);
        const payItemRealName = valuesStore.getArrayObjectsValue('pay_items', 'alias', record?.pay_item);
        const content = <div className='d-flex flex-column'>
            <div>
                <Divider orientation='center' className='fw-bold text-danger'>Transaction Details</Divider>
                <Space direction='vertical fw-bold'>
                    <label className='h4'>TxnID: {record?.bank_txn_id || 'N/A'}</label>
                    <label className='h4'>Amount: GHC {record?.amt_paid || 'N/A'}</label>
                    <label >Cheque No.: {record?.cheque_no || 'N/A'}</label>
                    <label>
                        Flow: <Tag
                            color={record?.debit_credit == 'dr' ? '#2db7f5' : 'geekblue-inverse'}
                        >{record?.debit_credit.toUpperCase() || 'N/A'}</Tag>
                    </label>

                    <label>Pay Item: {payItemRealName?.item || 'N/A'}</label>

                    <label>
                        Type: <Tag
                            color={record?.is_reversal ? 'grey' : '#00695c'}
                        >{record?.is_reversal ? 'Reversal' : 'Not Reversal'}</Tag>
                    </label>
                    {
                        !isMainTxn &&
                        <label> Action: {
                            record?.declined ?
                                <Tag color='volcano' icon={<i className='fas fa-trash' />}> {record?.status?.toUpperCase() || 'N/A'}</Tag>
                                : <Tag color='green' icon={<i className='fas fa-check' />}> {record?.status?.toUpperCase() || 'N/A'}</Tag>
                        }
                        </label>
                    }
                    <label>Description: {record?.description || 'N/A'}</label>
                    <label>Date: {record?.date_inserted || 'N/A'}</label>
                </Space>
            </div>

            <div>
                <Divider orientation='center' className='fw-bold text-danger'>Bio Details</Divider>
                <Space direction='vertical fw-bold'>
                    <label>Student First Name: {record?.fname ?? student?.fname ?? 'N/A'}</label>
                    <label>Student Surname: {record?.lname ?? student?.lname ?? 'N/A'}</label>
                    <label>Student Middle Name: {record?.mname ?? student?.mname ?? 'N/A'}</label>
                    <label>Student Sex: {record?.sex ?? student?.sex ?? 'N/A'}</label>
                    <label>Student Level: {record?.current_level ?? student?.current_level ?? 'N/A'}</label>
                    <label>Student Session: {record?.session ?? student?.session ?? 'N/A'}</label>
                    <label>Student Index No.: {record?.index_no ?? student?.index_no ?? 'N/A'}</label>
                    {isMainTxn && <label>Student Status: {record?.status ?? student?.status ?? 'N/A'} </label>}
                    <label>Payer Name: {record?.payer_name ?? student?.payer_name ?? 'N/A'}</label>
                    <label>Payer Contact: {record?.payer_contact ?? student?.payer_contact ?? 'N/A'}</label>

                </Space>
            </div>

            <div>
                <Divider orientation='center' className='fw-bold text-danger'>Bank Details</Divider>
                <Space direction='vertical fw-bold'>
                    <label>Bank: {record?.bank_code || 'N/A'}</label>
                    <label>Account: {record?.bank_acct || 'N/A'}</label>
                    <label>Payment Mode: {record?.payment_type || 'N/A'}</label>
                    <label>Teller: {record?.teller || 'N/A'}</label>
                </Space>
            </div>
        </div>
        drawer.setContent(content);
    },


    async changeTxnStatus(details, type, idField) {
        let url = '';
        switch (type) {
            case "review": {
                url = `${Settings.backend}/save_review_txn`;
                break;
            }
            case "approve": {
                url = `${Settings.backend}/save_approve_txn`;
                break;
            }
            case "decline": {
                url = `${Settings.backend}/save_decline_txn`;
                break;
            }
        }
        const data = details.map(v => (v[idField]));
        let res = await utils.requestWithReauth('post', url, null, { data });
        if (res.status === 'Ok') {
            message.success('Operation successful');
        } else {
            message.error(res.msg);
        }
    },


}

export default CustomFunctions;